export function logToDebugState(data: any = {}, slice: string = 'tmp') {
  const { default: configLib } = require('../../../configLib');
  const { store } = configLib ?? {};

  store?.dispatch({ type: 'debug', payload: { slice, data } });
}
